
import { /* Cartesian2, */ VerticalOrigin, HorizontalOrigin,
   Cartesian3,
  CustomDataSource } from "cesium/Cesium";
let PictureLayer = function(jsonData, params) {
  this.params = params;
  this.source = new CustomDataSource("PictureLayer");
  this._loadData(jsonData);
};

PictureLayer.prototype = {
  _loadData(data) {
    data.features.forEach(f => {
      let height = f.properties.height || 0;
      this.source.entities.add({
        position: Cartesian3.fromDegrees(f.geometry.coordinates[0], f.geometry.coordinates[1], height),
        billboard: {
          scale: this.params.scale,
          // pixelOffset: new Cartesian2(0.0, -10),
          horizontalOrigin: HorizontalOrigin.CENTER,
          verticalOrigin: VerticalOrigin.BOTTOM,
          image: this.params.imageUrl
        },
        properties: {
          ...f.properties,
          geometryType23: "Point",
          layerName23: this.params.layerName
        }
      });
    });
  }

};

export default PictureLayer;
